
export async function getIconStyles() {
    const icons = []

    icons.push(await getIconStyle(1, "Ceramics/Pottery"))
    icons.push(await getIconStyle(2, "Fibre/Textiles"))
    icons.push(await getIconStyle(3, "Glass"))
    icons.push(await getIconStyle(4, "Jewellery"))
    icons.push(await getIconStyle(5, "Mosaic"))
    icons.push(await getIconStyle(6, "Painting/Drawing"))
    icons.push(await getIconStyle(7, "Photography"))
    icons.push(await getIconStyle(8, "Printmaking"))
    icons.push(await getIconStyle(9, "Sculpture"))
    icons.push(await getIconStyle(10, "Woodwork"))
    icons.push(await getIconStyle(11, "Other"))
    icons.push(await getIconStyle(12, "Multiple/Exhibition Space"))
    return icons
}

async function getIconStyle(num, medium) {
    let response, svgText, svgUrl;
    response = await fetch(`/img/ArtsTrail/icons/icon-${num}.svg`);
    svgText = await response.text();
    svgUrl = 'data:image/svg+xml;base64,' + btoa(svgText);
    return {
        medium: medium,
        url: svgUrl
    }
}